import { Issue, IIssue } from 'app/constants/schemas/Issue';
import { ISound, Sound } from 'app/constants/schemas/Sound';
import { IImage, Image } from 'app/constants/schemas/Image';
import { IWordForm, WordForm } from 'app/constants/schemas/WordForm';
import { IWordTranslation, WordTranslation } from 'app/constants/schemas/WordTranslation';
import { DictionaryTag, DictionaryTagMarshaller } from 'app/constants/enums/DictionaryTag';
import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';
import { DateMarshaller } from 'app/constants/schemas/Date';
import { PartOfSpeech, PartOfSpeechMarshaller } from '../enums/PartOfSpeech';

export interface IWord extends IEntity {
  attributes: {
    language: Language;
    definition: string | null;
    id: EntityStringId;
    partOfSpeech: PartOfSpeech | null;
    pronunciations: string[];
    transliteration: string | null;
    word: string;
    internalTags: string[];
    dictionaryTags: DictionaryTag[];
    draft: boolean;
    createdAt: Date;
    updatedAt: Date;
    contentLevel: number | null;
  };
  associations: {
    sound: ISound | null;
    image: IImage | null;
    translations: IWordTranslation[];
    wordForms: IWordForm[];
    issues: IIssue[];
  };
}

export type Word = Entity<IWord>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Word: IEntityType<IWord> = vmClient.defineClass({
  typeName: 'Word',
  version: 8,
  lockable: true,
  persisted: true,
  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    word: {
      type: 'string',
      notNull: true,
    },
    definition: 'string',
    pronunciations: {
      type: 'string',
      collection: true,
      notNull: true,
    },
    internalTags: {
      type: 'string',
      collection: true,
      notNull: true,
    },
    transliteration: 'string',
    partOfSpeech: {
      type: PartOfSpeech,
      marshaller: PartOfSpeechMarshaller,
    },
    dictionaryTags: {
      type: DictionaryTag,
      marshaller: DictionaryTagMarshaller,
      collection: true,
      notNull: true,
    },
    draft: {
      type: 'boolean',
      notNull: true,
    },
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
    updatedAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
    contentLevel: 'number',
  },
  associations: {
    sound: Sound,
    image: Image,
    translations: {
      type: WordTranslation,
      collection: true,
      notNull: true,
    },
    wordForms: {
      type: WordForm,
      collection: true,
      notNull: true,
    },
    issues: {
      type: Issue,
      collection: true,
      notNull: true,
    },
  },
});
